import React, { useContext } from 'react';
import { NavLink } from "react-router-dom";
import posed from 'react-pose';

import { SessionContext } from "../../../hooks/wrappers/SessionWrapper";

import logo from "./../../../media/img/logo.svg"


const MoveImg = posed.img({
  open: { opacity: 1 },
  closed: { opacity: 0 }
});

const MoveSections = posed.div({
  open: { y: 0, opacity: 1 },
  closed: { y: 20, opacity: 0 }
});

const MoveOption = posed.div({
  open: { opacity: 1 },
  closed: { opacity: 0 }
});

const Nav = ({ closeMenu }) => {
  const { isLoggedIn, logout } = useContext(SessionContext)

  return (
    <nav className="container-fluid h-100 text-white">
      <div style={{ height: "200px" }} className="row justify-content-center p-4 mb-5">
        <MoveImg width="100%" style={{ maxHeight: "100%" }} src={logo} alt=""/>
      </div>
      <MoveSections className="row justify-content-center align-items-center">
        <NavLink onClick={closeMenu} to="bookings" style={{ fontSize: "30px" }}
                 className="text-center ff-bobby text-white">
          RESERVAS
        </NavLink>
      </MoveSections>
      <MoveSections className="row justify-content-center align-items-center">
        <NavLink onClick={closeMenu} to="vespas" style={{ fontSize: "30px" }} className="text-center ff-bobby">
          VESPAS
        </NavLink>
      </MoveSections>
      <MoveSections className="row justify-content-center align-items-center">
        <NavLink onClick={closeMenu} to="users" style={{ fontSize: "30px" }} className="text-center ff-bobby">
          USUARIOS
        </NavLink>
      </MoveSections>
      <MoveSections className="row justify-content-center align-items-center">
        <NavLink onClick={closeMenu} to="new-client" style={{ fontSize: "30px" }} className="text-center ff-bobby">
          NUEVO CLIENTE
        </NavLink>
      </MoveSections>
      <MoveSections className="row justify-content-center align-items-center">
        <NavLink onClick={closeMenu} to="estadistics" style={{ fontSize: "30px" }} className="text-center ff-bobby">
          ESTADISTICAS
        </NavLink>
      </MoveSections>
      <MoveSections className="row justify-content-center align-items-center">
        <NavLink onClick={closeMenu} to="settings" style={{ fontSize: "30px" }} className="text-center ff-bobby">
          AJUSTES
        </NavLink>
      </MoveSections>

      <MoveOption className="row w-100 justify-content-center align-items-center position-absolute mb-4"
                  style={{ bottom: 0 }}>
        {isLoggedIn ?
          <div onClick={() => {
            logout();
            closeMenu()
          }} style={{ fontSize: "30px", cursor: "pointer" }}
               className="text-center ff-bobby">
            LOGOUT
          </div> :
          <NavLink onClick={closeMenu} to="login" style={{ fontSize: "30px" }} className="text-center ff-bobby">
            LOGIN
          </NavLink>
        }
      </MoveOption>

    </nav>
  );
};

export default Nav;
